import React, { useState } from 'react';
import { shortSupplierName } from '../../lib/marketSupplierName';

/** A supplier's short name; the full name on hover (title) and on tap (toggles), for touch screens. */
export default function SupplierName({ name, prefix = '', className, style }) {
  const [full, setFull] = useState(false);
  if (!name) return null;
  const short = shortSupplierName(name);
  const canExpand = short !== name.trim();
  return (
    <span className={className} style={{ cursor: canExpand ? 'pointer' : undefined, ...style, ...(full ? { whiteSpace: 'normal', overflow: 'visible' } : null) }} dir="ltr" title={name} data-supplier-name={name} data-expandable={canExpand ? 1 : undefined}
      onClick={canExpand ? (e) => { e.stopPropagation(); e.preventDefault(); setFull((v) => !v); } : undefined}>
      {prefix}{full ? name : short}
    </span>
  );
}
